// The reports the project page renders, generated with il-report
// from plans/usage-demo-reports by scripts/build-usage-demo-reports.py.
// The layouts carry no absolute date: every date is a token relative to
// today ({{D+62}} long, {{DS+62}} short, {{MON+62}} month name, {{ISO+62}}),
// filled here so the reports keep their distance to the demo's today.

import { inDays, monthName } from "../model/fixtures";
import { longDate, shortDate } from "../model/format";
import type { ReportKey } from "../model/types";
import { OPPORTUNITY_MICROSOFT, OPPORTUNITY_SNOWFLAKE, PLAYBOOK_MICROSOFT } from "./generated";

const REPORTS: Record<ReportKey, string> = {
    OPPORTUNITY_MICROSOFT,
    OPPORTUNITY_SNOWFLAKE,
    PLAYBOOK_MICROSOFT,
};

const FORMATS: Record<string, (isoDate: string) => string> = {
    D: longDate,
    DS: shortDate,
    MON: monthName,
    ISO: (d) => d,
};

const fillDates = (html: string): string =>
    html.replace(/\{\{(D|DS|MON|ISO)([+-]\d+)\}\}/g, (_, kind: string, days: string) =>
        FORMATS[kind](inDays(Number(days)))
    );

export const reportHtml = (key: ReportKey): string => fillDates(REPORTS[key]);
